import React from 'react'

import { Tooltip } from "@mui/material";
import colors from '../../../Utils/colors';
import images from '../../../Utils/images';

const TicketComponent = ({ count, label, tooltipText }) => {
  return (
    <>
      <div
        className="ticket_component_container"
        style={{ backgroundColor: '#FAFAFA' }}
      >
        <p className="count_style">{count}</p>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            width: '100%',
          }}
        >
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
            <p className="label_style" style={{ margin: 0 }}>
              {label}
            </p>
            <Tooltip title= {tooltipText} arrow>
              <img
                style={{
                  height: 22,
                  width: 22,
                  objectFit: 'contain',
                  cursor: 'pointer',
                }}
                src={images.InfoCircle}
                alt="info"
              />
            </Tooltip>
          </div>
        </div>
      </div>

    </>
  )
}

export default TicketComponent